import PeppolIcon from 'assets/svg/icons/PeppolIcon';
import Banner from 'components/molecules/Banner/Banner.component';
import {
  AppBannersContext,
  BANNERS_STORAGE_KEYS,
} from 'contexts/AppBannersProvider';
import { useContext, type FC } from 'react';
import { useTranslation } from 'react-i18next';

const BelgiumPeppolVerificationBanner: FC = () => {
  const { t } = useTranslation();

  const { dismissBanner } = useContext(AppBannersContext);

  return (
    <Banner
      Icon={PeppolIcon}
      title={t('peppol.request_verification_banner.title.be')}
      href="/settings/peppol"
      linkLabel={t('peppol.request_verification_banner.cta.be')}
      onDismiss={() =>
        dismissBanner(
          BANNERS_STORAGE_KEYS.BELGIUM_PEPPOL_VERIFICATION_DISMISS_KEY,
        )
      }
    />
  );
};

export default BelgiumPeppolVerificationBanner;
